import { render, staticRenderFns } from "./status-badge.vue?vue&type=template&id=bf7f61b8&scoped=true&"
import script from "./status-badge.vue?vue&type=script&lang=js&"
export * from "./status-badge.vue?vue&type=script&lang=js&"
import style0 from "./status-badge.vue?vue&type=style&index=0&id=bf7f61b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7f61b8",
  null
  
)

/* custom blocks */
import block0 from "./status-badge.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports